<template>
	<div
		class="master-detail fill-height"
		:class="{ 'show-details': showDetails }"
	>
		<main class="fill-height" :style="mainStyle">
			<div class="scrollable">
				<slot />
			</div>
		</main>
		<aside :style="asideStyle">
			<div class="scrollable">
				<slot name="detail" />
			</div>
		</aside>
	</div>
</template>

<style lang="scss" scoped>
.master-detail {
	position: absolute;
	width: 100%;
	height: 100%;

	display: flex;
	flex: 1 1 auto;
	flex-direction: row;
	align-content: stretch;

	main,
	aside {
		position: relative;

		// Animate width and opacity changes
		transition: all 300ms;
	}

	main {
		flex: 1;
	}

	aside {
		width: 0;
		opacity: 0;

		background-color: white;
	}

	.scrollable {
		position: absolute;
		width: 100%;
		height: 100%;
		overflow-y: auto;
	}

	// For when we're showing the details div.
	&.show-details {
		aside {
			opacity: 1;
			border-left: thin solid rgba(0, 0, 0, 0.12);
			border-top: thin solid rgba(0, 0, 0, 0.12);
		}

		@media #{map-get($display-breakpoints, 'sm-and-down')} {
			aside {
				position: absolute;
				right: 0;
				width: 100% !important;
				height: 100%;
				overflow-y: auto;
				border-left: none;
			}
		}
	}
}
</style>

<script>
export default {
	props: {
		showDetails: {
			type: Boolean,
			required: false,
			default: true,
		},

		// Must be a number <= 100 representing % size of main content to show when
		// the "aside" view is expanded on non-mobile browsers.
		asideSize: {
			type: Number,
			default: 40,
		},
	},

	computed: {
		mainStyle() {
			const pct = this.showDetails ? 100 - this.asideSize : 100;
			return { width: `${pct}%` };
		},

		asideStyle() {
			const pct = this.showDetails ? this.asideSize : 0;
			return { width: `${pct}%` };
		},
	},
};
</script>
